module.exports = __webpack_public_path__ + "media/images/logos/adweek-bafff931834aedc522eacf77494d4a69.png";